module.exports = __webpack_public_path__ + "img/Homepage-UI.bc95d1e1.jpg";